import { render } from "./kalio-back-button.vue?vue&type=template&id=1c48ea0c"
import script from "./kalio-back-button.vue?vue&type=script&lang=js"
export * from "./kalio-back-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__